module.exports = __webpack_public_path__ + "static/img/logos.4cac033.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logos.png
// module id = f6ZA
// module chunks = 1